import React, { Component } from 'react'

export default class Collections extends Component {
  render() {
    return (
      <section className="colorlib-work" data-section="Collections">
        <div className="colorlib-narrow-content">
          <div className="row">
            <div className="col-md-6 col-md-offset-3 col-md-pull-3 animate-box" data-animate-effect="fadeInLeft">
              <span className="heading-meta">Collections</span>
              <h2 className="colorlib-heading animate-box">Miscellaneous</h2>
            </div>
          </div>

          <div className="col-md-12">
            <div className="about-desc">
              <a href="https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDY2MTY4Mw==&hid=1&sn=82811e9549b2eb0d590ac00ee813c202">Reading notes in neuroscience (Chinese), 2021 summer</a>
              <hr />
              <a href="https://mp.weixin.qq.com/mp/homepage?__biz=Mzg4MDY2MTY4Mw==&hid=4&sn=c9529691da68781b053232be0755460b">Mathematical Collections (Chinese)</a>
              <hr />
              <iframe src="//player.bilibili.com/player.html?aid=508897519&bvid=BV1tu41197GF&cid=507433080&page=1&autoplay=0&t=2&muted=1&danmaku=false" title="pre" scrolling="no" border="0" frameborder="no" framespacing="0" height='450' width='600' allowfullscreen="true"> </iframe>
              <p>An introduction to dimension reduction methods in neuroscience (Chinese), invited by Univeron, 2021 winter</p>
              <hr></hr>
              <div class="panel-group" id="accordion">

                <div class="panel panel-default">
                  <div class="panel-heading">
                    <h4 class="panel-title">
                      <a data-toggle="collapse" data-parent="#accordion"
                        href="#collapseOne">
                        PDF files download
                      </a>
                    </h4>
                  </div>
                  <div id="collapseOne" class="panel-collapse collapse">
                    <div class="panel-body">
                      <a href='./collections/topo.pdf'> Propositions about set theory and natural numbers (Chinese) </a> 
                    </div>
                    <div class="panel-body">
                      <a href='./collections/topo2.pdf'> Compactness and Tychonoff theorem (Chinese) </a> 
                    </div>
                    <div class="panel-body">
                      <a href="./collections/Sophomore's Dream.pdf"> Sophomore's Dream, an interesting integral </a> 
                    </div>
                    <div class="panel-body">
                      <a href="./collections/PCA_notes.pdf"> An introduction to PCA (Chinese) </a> 
                    </div>
                  </div>
                </div>

              </div>
            </div>
          </div>

        </div>
      </section>
    )
  }
}
